import React, { useState, useEffect } from 'react'
import { useSearchParams} from "react-router-dom";

import { DataGrid } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import { Grid, Typography } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';

import DeleteNotification from '../../core/components/DeleteNotification';
import {CoreContext} from "../../core/context/CoreContext";
import PageWaiting from '../../core/components/PageWaiting';
import {isMobile} from 'react-device-detect';

import {getListAPI, deleteAPI} from './RawdemandAPI';
import {getColumns} from './RawdemandStruct';
import ListCardView from '../../core/components/card/ListCardView';
import ListTableView from '../../core/components/card/ListTableView';

import {getRawdemandView} from './RawdemandView';
import CardListLayout from '../../core/components/card/layout/CardListLayout';
import { useSelector, useDispatch } from 'react-redux';
import {setViewParams} from '../../store/slice/ChoiceSelectionSlice';

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ViewWeekIcon from '@mui/icons-material/ViewWeek';
import CalendarViewMonthIcon from '@mui/icons-material/CalendarViewMonth';

import {setFilter} from '../../store/slice/ConfSlice';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import MyPageContainer from '../../core/template/MyPageContainer';
import { deleteRawdemandObj  ,setSelectedRawdemandId,setRawdemandQuotationmgmtModal,setSelectedActionId , setShowEditForRawdemand} from 'store/slice/PharmaSlice';

import RawdemandListTable from './components/RawdemandListTable';
import { useNavigate } from "react-router-dom";
import { setClickedBo,setActionClicked } from 'store/slice/BreadCrumSlice';


import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';

import QuotationmgmtActionModal from './action/quotationmgmt/QuotationmgmtActionModal';

import { transformDateValue } from 'core/js/FormUtils';
import VendorRawdemandListTable from './components/VendorRawdemandListTable';

export default function RawdemandListImpl( {tableList, cardList, setShowEdit, setRawdemandId}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setNotification, setShowLoading, showloading, lastURL } = React.useContext(CoreContext);
  const columns = getColumns(editCallBack, initDeleteCallBack);
  const [view, setView] = useState(1);
  const { showfilter } = useSelector((state) => state.confslice)

  const [showDeleteAlert, setShowDeleteAlert] = useState(false);
  const {selectedId, rawdemandObj} = useSelector((state)=>state.pharmaslice.rawdemandDashboard);
  const { rawdemandList } = useSelector((state) => state.pharmaslice.rawdemandDashboard);

  useEffect(() => {
  }, [rawdemandList, rawdemandObj])
  
  function initDeleteCallBack(id){
    dispatch(setSelectedRawdemandId(id));
    setShowDeleteAlert(true);
  }
  function deleteCallBack(obj){
    dispatch(deleteRawdemandObj(obj.id));
    setNotification('Record deleted successfully !!!')
  }
  function deleteRecord(){
    deleteAPI(selectedId,deleteCallBack);
    setShowDeleteAlert(false);
  }

  function editCallBack(id){
    dispatch(setSelectedRawdemandId(id));
    dispatch(setShowEditForRawdemand(true));
  }
  
  const createRawdemand=()=>{
    dispatch(setSelectedRawdemandId(-1));
    dispatch(setShowEditForRawdemand(true));
  }


  const quotationmgmtCallBack = (id) =>{
    dispatch(setSelectedRawdemandId(id));
    dispatch(setRawdemandQuotationmgmtModal(true));
  }

const getDataWithDateTransformation = (data) =>{
    let newData = {
      ...data,
      'expand':false,

    }
    return newData;
  }
  const rawdemandTransformation = (tableList) =>{
    let newDataList=[]
    tableList.map((data)=>{ 
      newDataList.push(getDataWithDateTransformation(data));
     })
    return newDataList;
  }

  const payload = {
    rawdemandList:rawdemandList,
    cardList:getRawdemandView(tableList),
        actionList: [
          {title:'Edit', callBackMethod:editCallBack, icon:<EditIcon/>, status:'NA'},
          {title:'Delete', callBackMethod:initDeleteCallBack, icon:<DeleteIcon/>, status:'NA'},
          
        {id:41, title:'Quotation Mgmt', callBackMethod:quotationmgmtCallBack, icon:<CurrencyRupeeIcon/>, status:'Draft', role:''},
        ],
        dialogueActionList: [
          
        ],
    tableView:{
      tableList:rawdemandTransformation(tableList),
      rawdemandList:rawdemandList,
      actionList:[
        {title:'Edit', callBackMethod:editCallBack, icon:<EditIcon/>, status:'NA'},
        {title:'Delete', callBackMethod:initDeleteCallBack, icon:<DeleteIcon/>, status:'NA'},
        
        {id:41, title:'Quotation Mgmt', callBackMethod:quotationmgmtCallBack, icon:<CurrencyRupeeIcon/>, status:'Draft', role:''},
      ]
    }
  }
  
  const getPayload = ()=>{
    return payload;
  }

  useEffect(()=>{
    if (document.body.offsetWidth<500)  setView(0);
    dispatch(setViewParams({
      colsCount:{xs:12, sm:4, md:4, lg:4},
      modal:{
            
      }
      }))
  },[])

  return (
   <>
   {showloading?<PageWaiting/>:
      <Grid container direction="column" padding={2}>
              <Grid item>
                  <Grid container direction="row" justifyContent={'space-between'} alignContent={'center'}>
                      <Grid item>
                        <Typography variant='h4'>Raw Material Demand List</Typography>
                      </Grid>
                      <Grid item>
                        <Grid container justifyContent={'flex-end'} spacing={1}>
                        {showfilter?
                            <Grid item>
                              <Tooltip title="Hide filter" sx={{cursor: "pointer"}}>
                                <FilterAltOffIcon onClick={()=>{dispatch(setFilter(false))}}/>
                              </Tooltip>
                            </Grid>
                            :
                            <Grid item>
                              <Tooltip title="Show filter" sx={{cursor: "pointer"}}>
                                <FilterAltIcon onClick={()=>{dispatch(setFilter(true))}}/>
                              </Tooltip>
                            </Grid>
                            }
                            {view===1?
                            <Grid item>
                              <Tooltip title="Grid View" sx={{cursor: "pointer"}}>
                                <ViewWeekIcon onClick={()=>{setView(0)}}/>
                              </Tooltip>
                            </Grid>
                            :
                            <Grid item>
                              <Tooltip title="Table View" sx={{cursor: "pointer"}}>
                                <CalendarViewMonthIcon onClick={()=>{setView(1)}}/>
                              </Tooltip>
                            </Grid>
                            }
                            <Grid item>
                              <Tooltip title="Add Rawdemand" sx={{cursor: "pointer"}}>
                                <AddIcon onClick={()=>{createRawdemand()}}/>
                              </Tooltip>
                            </Grid>
                          </Grid>
                      </Grid>
                      
                  </Grid>
              </Grid>
              <Grid item>
                  { view===0? 
                      <CardListLayout payload={getPayload()}/>
                    :
                    // <MyPageContainer  containedComponent = {
                    <>
                    <Grid  container direction="row" >
                      <Grid item lg={6} >
                      < RawdemandListTable 
                          payload={getPayload().tableView}
                          />
                      </Grid>
                      <Grid item lg={6} >
                        <VendorRawdemandListTable
                        payload={getPayload().tableView}
                        />
                      </Grid>
                    </Grid>
                      
                      </>
                    // }/>
                  }
              </Grid>        
      </Grid>
   }
    { showDeleteAlert?<DeleteNotification 
            id={selectedId}
            width="50%"
            setShowDeleteAlert={setShowDeleteAlert}
            deleteRecord = {deleteRecord}/>: ''
    }

    
<QuotationmgmtActionModal/>
    </>
);


}